import { X } from 'lucide-react';

export default function QuoteModal({ isOpen, onClose }) {
  const phoneNumber = '0690579693';
  const whatsappNumber = '27690579693';

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="quote-modal">
      <div className="relative max-w-2xl w-full bg-blackline-bg border-2 border-blackline-accent p-8 md:p-12">
        <button
          onClick={onClose}
          data-testid="modal-close-button"
          className="absolute top-4 right-4 text-zinc-400 hover:text-white transition-colors splash-action"
        >
          <X size={24} />
        </button>

        <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase text-white mb-4" data-testid="modal-title">
          GET YOUR QUOTE
        </h2>
        <p className="font-mono text-sm text-zinc-400 mb-12">
          Choose a direct contact method
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a
            href={`tel:${phoneNumber}`}
            data-testid="modal-call-button"
            className="border-2 border-blackline-border p-6 hover:border-blackline-accent hover:bg-blackline-accent hover:text-black transition-all group text-center splash-action"
          >
            <div className="text-4xl mb-3">📞</div>
            <h3 className="font-oswald text-lg font-bold uppercase text-white group-hover:text-black mb-2">
              CALL
            </h3>
            <p className="font-mono text-sm text-zinc-400 group-hover:text-black">
              069 057 9693
            </p>
          </a>

          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="modal-whatsapp-button"
            className="border-2 border-blackline-border p-6 hover:border-blackline-accent hover:bg-blackline-accent hover:text-black transition-all group text-center splash-action"
          >
            <div className="text-4xl mb-3">💬</div>
            <h3 className="font-oswald text-lg font-bold uppercase text-white group-hover:text-black mb-2">
              WHATSAPP
            </h3>
            <p className="font-mono text-sm text-zinc-400 group-hover:text-black">
              Chat now
            </p>
          </a>
        </div>
      </div>
    </div>
  );
}